import { marginBottom, marginTop } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  ${marginTop(20)};
  text-align: center;
`;
export const SVG = styled.svg `
  ${marginBottom(-9)};
`;
